module.exports = __webpack_public_path__ + "media/icons/blue-bell-4255f581.png";